export default process.env.ENVIRONMENT === 'prod' || window.location.href.indexOf('prod') > -1
    ? {
          domain: 'acacia.au.auth0.com',
          clientId: 'kNmcuOO31U8E8f0I6te6j4R36el5zDR8',
      }
    : {
          domain: 'mynance-demo.au.auth0.com',
          clientId: 'BcPTBeQ6a4AvlzsBNNc5Dn2W6LG7eGcy',
      }
